module.exports = __webpack_public_path__ + "img/polygon_network_nft_details.dbf2c693.svg";